// Resolves the price a customer should see, given:
//   * the item (with optional `priceLevels` map),
//   * the authenticated user (with optional `priceLevel`),
//   * a per-color `priceAdjustment`,
//   * and the active site mode.
//
// Public site (mysteryranch.com): show MSRP, regardless of who is logged in.
//   Public visitors see retail; their NetSuite price-level only kicks in
//   on the B2B side.
//
// B2B site (b2b.mysteryranch.com): show the customer's assigned price level,
//   falling back to base when anonymous or when the level isn't priced.
//
// `dual` mode is decided upstream in SiteModeContext: anonymous → public,
// authenticated B2B user → b2b.

import { DEFAULT_CURRENCY } from "./money";

export function effectivePrice(item, user, opts = {}) {
  if (!item) return item;
  const siteMode = opts.siteMode || "b2b";
  const levels = item.priceLevels || {};

  let level;
  if (siteMode === "public") {
    level = "msrp";
  } else {
    level = (user && user.priceLevel) || "base";
  }

  const baseAmount =
    levels[level] ??
    levels.base ??
    levels.msrp ??
    (item.price && typeof item.price === "object" ? item.price.amount : Number(item.price)) ??
    0;

  const colorAdj = opts.color?.priceAdjustment || 0;
  const amount = Number(baseAmount) + Number(colorAdj || 0);
  const currency = (item.price && item.price.currency) || DEFAULT_CURRENCY;
  return {
    ...item,
    price: { amount, currency },
    prices: [{ amount, currency }],
    priceLevelUsed: level,
  };
}
